import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FiArrowDown } from "react-icons/fi"; // Optional icon, can replace with an arrow symbol

const DownArrow = () => {
    const [isVisible, setIsVisible] = useState(true); // State to track if arrow is visible

    // Handle the scroll event
    const handleScroll = () => {
        const scrollPosition = window.scrollY;
        const documentHeight = document.documentElement.scrollHeight;
        const windowHeight = window.innerHeight;

        // Check if user has reached the bottom of the page
        if (scrollPosition + windowHeight >= documentHeight - 100) {
            setIsVisible(false);
        } else {
            setIsVisible(true);
        }
    };


    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScrollToSection = () => {
        // Scroll to the next section (ID: next-section)
        const nextSection = document.getElementById("next-section");
        if (nextSection) {
            nextSection.scrollIntoView({ behavior: "smooth" });
        }
    };

    if (!isVisible) return null;

    return (
        <motion.div
            className="down-arrow"
            onClick={handleScrollToSection}
            style={{
                position: "fixed",
                right: "30px",
                bottom: "50px",
                cursor: "pointer",
                zIndex: 1,
            }}
            animate={{ y: [0, -10, 0] }}
            transition={{
                y: {
                    repeat: Infinity,
                    repeatType: "loop",
                    duration: 1.5,
                    ease: "easeInOut",
                },
            }}
        >
            <FiArrowDown size={40} style={{ mixBlendMode: 'difference' }} />
            <div style={{ fontSize: "15px", color: 'white', mixBlendMode: 'difference' }}>Scroll to Know More</div>
        </motion.div>
    );
};

export default DownArrow;
